module.exports = __webpack_public_path__ + "static/media/people3.c5aa5de4.jpg";